<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="customCheck1" [checked]="isAdvancedChange"
                (change)="toggleAdvancedUpload($event)" />
            <label class="custom-control-label" for="customCheck1">Excel ile yükleme</label>
        </div>

        <div id="stepper1" class="bs-stepper horizontal-wizard-example">
            <div class="bs-stepper-header">
                <div class="step" data-target="#product-info">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">1</span>
                        <span class="bs-stepper-label">
                            <span class="bs-stepper-title">Ürün Bilgileri</span>
                            <span class="bs-stepper-subtitle">Ürün bilgilerini girin</span>
                        </span>
                    </button>
                </div>
                <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                <div class="step" data-target="#price-tax-info">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">2</span>
                        <span class="bs-stepper-label">
                            <span class="bs-stepper-title">Fiyat ve Vergi Bilgileri</span>
                            <span class="bs-stepper-subtitle">Fiyat ve vergi bilgilerini girin</span>
                        </span>
                    </button>
                </div>
                <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                <div class="step" data-target="#category-warehouse-info">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">3</span>
                        <span class="bs-stepper-label">
                            <span class="bs-stepper-title">Kategori ve Birim</span>
                            <span class="bs-stepper-subtitle">Kategori ve birim bilgilerini girin</span>
                        </span>
                    </button>
                </div>
                <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                <div class="step" data-target="#labels-info">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">4</span>
                        <span class="bs-stepper-label">
                            <span class="bs-stepper-title">Etiketler ve Alt Ürünler</span>
                            <span class="bs-stepper-subtitle">Etiketler ve alt ürünler bilgilerini girin</span>
                        </span>
                    </button>
                </div>
            </div>

            <div class="bs-stepper-content">
                <form [formGroup]="productForm" (ngSubmit)="onSubmit()" (submit)="preventSubmit($event)">
                    <!-- Ürün Bilgileri Adımı -->
                    <div id="product-info" class="content">
                        <div class="content-header">
                            <h5 class="mb-0">Ürün Bilgileri</h5>
                            <small>Ürün bilgilerini girin.</small>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="productName">Ürün Adı</label>
                                <input formControlName="name" type="text" id="productName" class="form-control"
                                    oninput="this.value = this.value.toUpperCase()" placeholder="Ürün Adı" />
                                <div *ngIf="productForm.get('name').hasError('required')">
                                    <small class="text-danger">Ürün adı zorunludur.</small>
                                </div>
                                <div *ngIf="productForm.get('name').hasError('maxlength')">
                                    <small class="text-danger">Ürün adı en fazla 50 karakter uzunluğunda
                                        olabilir.</small>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="productName">Kod</label>
                                <input formControlName="code" type="text" id="code" class="form-control" maxlength="16"
                                    placeholder="Ürün Adı" />
                                <div *ngIf="productForm.get('code').hasError('maxlength')">
                                    <small class="text-danger">Ürün Kodu en fazla 16 karakter uzunluğunda
                                        olabilir.</small>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="productType">Ürün Türü</label>
                                <select formControlName="productType" id="productType" class="form-control">

                                    <option value='true'>Ürün</option>
                                    <option value='false'>Hizmet</option>
                                </select>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-outline-outline-secondary btn-prev" disabled>
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Önceki</span>
                            </button>
                            <button type="button" class="btn btn-outline-primary btn-next"
                                (click)="horizontalWizardStepperNext('product-info')">
                                <span class="align-middle d-sm-inline-block d-none">Sonraki</span>
                                <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Fiyat ve Vergi Bilgileri Adımı -->
                    <div id="price-tax-info" class="content">
                        <div class="content-header">
                            <h5 class="mb-0">Fiyat ve Vergi Bilgileri</h5>
                            <small>Fiyat ve vergi bilgilerini girin.</small>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="purchasePrice">Alış Fiyatı</label>
                                <input formControlName="purchasePrice" type="number" id="purchasePrice"
                                    class="form-control" placeholder="Alış Fiyatı" />
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="salePrice">Satış Fiyatı</label>
                                <input formControlName="salePrice" type="number" id="salePrice" class="form-control"
                                    placeholder="Satış Fiyatı" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="purchaseTaxId">Alış Vergisi</label>
                                <select formControlName="purchaseTaxId" class="form-control">
                                    <option *ngFor="let tax of taxes" [value]="tax.id">{{ tax.taxRate }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="saleTaxId">Satış Vergisi</label>
                                <select formControlName="saleTaxId" class="form-control">
                                    <option *ngFor="let tax of taxes" [value]="tax.id">{{ tax.taxRate }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label class="form-label" for="currencyId">Para Birimi</label>
                                <select formControlName="currencyId" class="form-control">
                                    <option *ngFor="let currency of currencies" [value]="currency.id">{{
                                        currency.currencyName
                                        }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-outline-primary btn-prev"
                                (click)="horizontalWizardStepperPrevious()">
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Önceki</span>
                            </button>
                            <button type="button" class="btn btn-outline-primary btn-next"
                                (click)="horizontalWizardStepperNext('price-tax-info')">
                                <span class="align-middle d-sm-inline-block d-none">Sonraki</span>
                                <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Kategori ve Depo Adımı -->
                    <div id="category-warehouse-info" class="content">
                        <div class="content-header">
                            <h5 class="mb-0">Kategori Ve Birim</h5>
                            <small>Kategori ve birim bilgilerini girin.</small>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="form-label" for="categoryId">Kategori</label>
                                <select formControlName="categoryId" class="form-control">
                                    <option *ngFor="let category of categories" [value]="category.id">
                                        {{ category.categoryName }}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="form-label" for="unitTypeId">Birim</label>
                                <select formControlName="unitTypeId" class="form-control">
                                    <option *ngFor="let unitType of unitTypes" [value]="unitType.id">
                                        {{ unitType.unitTypeName }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-6 row">
                                <label class="form-label ml-1" for="brandModalId">Model Seç</label>

                                <ng-select [searchFn]="searchFn" [items]="brands" bindLabel="name" bindValue="id"
                                    groupBy="brandName" formControlName="brandModalId" class="col-11">
                                    <ng-template ng-optgroup-tmp let-item="item">
                                        {{ item.brandName || 'Unnamed group' }}
                                    </ng-template>
                                </ng-select>
                                <button type="button" class="btn btn-sm btn-flat-primary col-1"
                                    (click)="openCreateBrandModelDialog()">
                                    <span [data-feather]="'plus'"></span>
                                </button>
                            </div>


                        </div>
                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-outline-primary btn-prev"
                                (click)="horizontalWizardStepperPrevious()">
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Önceki</span>
                            </button>
                            <button type="button" class="btn btn-outline-primary btn-next"
                                (click)="horizontalWizardStepperNext('category-warehouse-info')">
                                <span class="align-middle d-sm-inline-block d-none">Sonraki</span>
                                <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Etiketler ve Alt Ürünler Adımı -->
                    <div id="labels-info" class="content">

                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="labels">Etiketler</label>
                                <div class="editable-container">
                                    <div class="chip-container">
                                        <div *ngFor="let label of labels" class="chip">
                                            {{ label }}
                                            <button type="button" class="close" aria-label="Close"
                                                (click)="removeLabel(label)">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="editable-area" contenteditable="true" (keydown.enter)="addLabel($event)"
                                        placeholder="Etiket Giriniz. Enter ile ekleyin." #editableArea></div>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="barcode">Barkod</label>
                                <input formControlName="barcode" type="text" id="barcode" class="form-control"
                                    placeholder="Ürün Barkodu" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="criticalStock">Kritik Stok</label>
                                <input formControlName="criticalStock" type="text" id="criticalStock"
                                    class="form-control" placeholder="Ürün Barkodu" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 mb-1">
                                <div class="card-body invoice-padding invoice-product-details">
                                    <form (ngSubmit)="onSubmit()">
                                        <div data-repeater-list="group-a">
                                            <div class="repeater-wrapper" data-repeater-item
                                                *ngFor="let item of items; let i = index">
                                                <div class="item-container">
                                                    <div class="row">
                                                        <div
                                                            class="col-12 d-flex product-details-border position-relative pr-0">
                                                            <div class="row w-100 pr-lg-0 pr-1 py-2">
                                                                <div class="col-lg-10 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
                                                                    <p class="card-text col-title mb-md-50 mb-0">Ürün
                                                                    </p>
                                                                    <select class="form-control item-details"
                                                                        [(ngModel)]="item.itemId" name="itemId{{ i }}"
                                                                        id="itemId{{ i }}">
                                                                        <option value="" disabled>Ürün Seçiniz</option>
                                                                        <option *ngFor="let product of products"
                                                                            [value]="product.id">{{product.name}}
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                                <div class="col-lg-2 col-12 my-lg-0 my-2">
                                                                    <p class="card-text col-title mb-md-2 mb-0">Adet</p>
                                                                    <div class="d-flex align-items-center">
                                                                        <input type="number" class="form-control"
                                                                            [(ngModel)]="item.count" name="count{{ i }}"
                                                                            id="count{{ i }}" placeholder="1" />
                                                                        <button type="button" (click)="deleteItem(i)"
                                                                            class="btn btn-danger btn-sm ml-2 d-flex align-items-center">
                                                                            <i data-feather="x" [size]="18"
                                                                                class="text-white"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-1">
                                            <div class="col-12 px-0">
                                                <button type="button" class="btn btn-flat-success btn-sm btn-add-new"
                                                    (click)="addItem()" rippleEffect>
                                                    <i data-feather="plus" class="mr-25"></i>
                                                    <span class="align-middle">Alt Ürün Ekle</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12 mb-1">
                                <div class="card-body invoice-padding">
                                    <form>
                                        <div data-repeater-list="serial-numbers">
                                            <div class="repeater-wrapper" data-repeater-item
                                                *ngFor="let serialNumber of serialNumbers; let i = index">
                                                <div class="item-container">
                                                    <div class="row">
                                                        <div class="col-xl-5 col-md-7 d-flex position-relative pr-0">
                                                            <div class="row w-100 pr-lg-0 pr-1 py-2">
                                                                <div class="col-lg-10 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
                                                                    <input type="text" class="form-control"
                                                                        maxlength="50"
                                                                        [(ngModel)]="serialNumbers[i].serialNumber"
                                                                        name="serialNumber{{ i }}"
                                                                        placeholder="Seri Numarası" />
                                                                </div>
                                                                <div class="col-lg-2 col-12 my-lg-0 my-2">
                                                                    <button type="button"
                                                                        (click)="deleteSerialNumber(i)"
                                                                        class="btn btn-danger btn-sm ml-2 d-flex align-items-center">
                                                                        <i data-feather="x" [size]="18"
                                                                            class="text-white"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-1">
                                            <div class="col-12 px-0">
                                                <button type="button" class="btn btn-flat-success btn-sm btn-add-new"
                                                    (click)="addSerialNumber()" rippleEffect>
                                                    <i data-feather="plus" class="mr-25"></i>
                                                    <span class="align-middle">Seri Numarası Ekle</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>


                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-outline-primary btn-prev"
                                (click)="horizontalWizardStepperPrevious()">
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Önceki</span>
                            </button>
                            <button type="submit" class="btn btn-outline-success btn-next"
                                [disabled]="!productForm.valid">
                                <span class="align-middle d-sm-inline-block d-none">Gönder</span>
                                <i data-feather="check" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div *ngIf="isAdvancedChange" class="card mt-2">
            <div class="form-group">
                <div class="col-12 d-flex justify-content-between">
                    <div class="col-4">
                        <label for="basicInputFile">Ürün Yükle</label>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile" (change)="onFileChange($event)"
                                accept=".xlsx, .xls" #fileInput />
                            <label class="custom-file-label" for="customFile">Excel dosyası seçiniz</label>
                        </div>
                    </div>
                    <div class="col-4 mt-2 d-flex justify-content-between">
                        <button type="button" class="btn btn-outline-danger" rippleEffect
                            (click)="resetFileInput(fileInput)">Dosyayı sil</button>

                        <a href="assets/excels/ornek_urun.xlsx" download="Urun_Listesi_Şablonu.xlsx" class="btn btn-outline-info"
                            rippleEffect>
                            <span [data-feather]="'arrow-down'" [class]="'mr-25'"></span>
                            Şablon
                        </a>
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Ürün Adı</th>
                            <th>Satış Fiyat</th>
                            <th>Alış Fiyat</th>
                            <th>Para Birimi</th>
                            <th>Alış Vergi</th>
                            <th>Satış Vergi</th>
                            <th>Kategori</th>
                            <th>Birim</th>
                            <th>Tip</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of productsExcel; let i = index">
                            <td>{{i + 1}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.salePrice}}</td>
                            <td>{{item.purchasePrice}}</td>
                            <td>{{item.currency?.currencyName}}</td>
                            <td>{{item.purchaseTax?.taxRate}}</td>
                            <td>{{item.saleTax?.taxRate}}</td>
                            <td>{{item.categori?.categoryName}}</td>
                            <td>{{item.unitType?.unitTypeName}}</td>
                            <td>{{ item.productType === true ? 'Ürün' : item.productType === false ? 'Hizmet' : '' }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <button type="button" class="btn btn-success d-flex ml-1 mt-2 mb-2" rippleEffect
                    [disabled]="!isProductsValid || !allProductsValid" (click)="saveProducts()">Kaydet</button>
            </div>
        </div>
    </div>
</div>